module.exports = __webpack_public_path__ + "static/img/13.dd3b9e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/eng/13.png
// module id = CbOC
// module chunks = 0